var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade-slide"}},[(_vm.$sidebar.isOpen)?_c(_vm.$sidebar.type,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }